import React, { useRef } from "react";
import RecommendCard from "../components/recommend/RecommendCard";
// components
import Iconify from "../components/Iconify";
import HeadingAnimate from "../components/animate/HeadingAnimate";
import LoadAnimate from "../components/animate/LoadAnimate";
// mocks
import { recommendData } from "../mock/recommend";
// ----------------------------------------------------------------------

export default function Recommend() {
  const ref = useRef();
  return (
    <>
      <div id="testimonials" />
      <div className="bg-[#100f0f] pb-20">
        <section className="container mx-auto pt-12 text-center sm:pt-20">
          <h2 className="text-center font-lato text-3xl font-semibold text-primary-700 dark:text-cyan-400 sm:text-5xl">
            TESTIMONIALS
          </h2>

          <LoadAnimate amount={0}>
            <div className="pt-8 w-full sm:pt-12">
              <RecommendCard></RecommendCard>
            </div>
          </LoadAnimate>
        </section>

        {/* <section className="container mx-auto mt-12 text-center sm:mt-20">
        <HeadingAnimate amount={1}>
          <h2 className="text-center font-lato text-3xl font-semibold text-primary-700 dark:text-cyan-400 sm:text-5xl">
            MEMBERSHIP
          </h2>
        </HeadingAnimate>

        <LoadAnimate amount={0}>
          <div className="sm:mt-12 mt-8 w-full">member</div>
        </LoadAnimate>
      </section> */}
      </div>
    </>
  );
}
